import { App, watch } from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { useInstances } from '@/hooks/use-instances';
import { useAccountStore } from '@/store/account';
import { sentryDsn, name } from '@root/package.json';
import { currentEnv } from '../http/env';

const initSentry = (app: App) => {
  const { getVueRouterInstance } = useInstances();
  const router = getVueRouterInstance();
  Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 1.0,
    environment: currentEnv,
  });
};

/**
 * 配置用户信息
 */
const initSentryUserInfo = () => {
  const accountStore = useAccountStore();
  // 已登录的无法触发watch，所以手动获取
  Sentry.setUser({ id: accountStore.account?.account?.id, username: accountStore.account?.account?.name });
  // 重新登录触发watch，重新设置信息
  watch(
    () => accountStore.account,
    (value) => {
      if (value) {
        Sentry.setUser({ id: value.id, username: value.account?.name });
      }
    },
  );
};

export default {
  install(app: App) {
    if (currentEnv === 'prod' && sentryDsn) {
      initSentry(app);
      initSentryUserInfo();
    }
  },
};
